import { ApiResponse, AxiosErrorCustom, axiosInstance } from '@/lib/axios';
import { TypedMutationConfig } from '@/lib/react-query';
import { useMutation } from '@tanstack/react-query';
import { z } from 'zod';
import { TLabelTicket } from '../types/label-ticket.type';

export const UpdateLabelTicketValidationSchema = z.object({
  labelTicketId: z.string({ message: 'Label ID is required' }).min(1),
  name: z.string().min(1).optional(),
  color: z.string().min(1).optional(),
});
export type TUpdateLabelTicketValidation = z.infer<typeof UpdateLabelTicketValidationSchema>;
export type TUpdateLabelTicketPayload = TUpdateLabelTicketValidation;
export type TUpdateLabelTicketResponse = ApiResponse<TLabelTicket>;

export const updateLabelTicket = async (payload: TUpdateLabelTicketPayload): Promise<TUpdateLabelTicketResponse> => {
  const url = `/label-ticket/${payload.labelTicketId}`;

  const payloadData = {
    name: payload?.name,
    color: payload?.color,
  };

  return axiosInstance.patch(url, payloadData);
};

/**
 * Use Update Ticketing Label React-Query Hook
 */
type UseUpdateLabelTicketMutationOptions = {
  mutationConfig?: TypedMutationConfig<typeof updateLabelTicket, AxiosErrorCustom>;
};

export const useUpdateLabelTicketMutation = ({ mutationConfig }: UseUpdateLabelTicketMutationOptions) => {
  const { ...restConfig } = mutationConfig ?? {};

  return useMutation({
    mutationFn: updateLabelTicket,
    ...restConfig,
  });
};
